import './apiVersion.interceptor';

const apiVersions: Record<string, string> = {};

type SineAPI = 'web-check-in' | 'core';

const apiVersionService = {
  getApiVersion(serviceKey: SineAPI) {
    return apiVersions[serviceKey];
  },
  setApiVersion(serviceKey: SineAPI, value: string) {
    apiVersions[serviceKey] = value;
  },
};

export default apiVersionService;
